import { useTranslation } from "react-i18next";
import { Empty, message, Modal } from "antd";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { deleteTeacherReplyStudent, teacherReplyStudent, updateTeacherReplyStudent } from "../../../../../../service/course-management";
import { CourseManagementStore } from "../../../../../../stores/stores";
import { CommentsBeProps, DiscussionProps } from "../../../../../../types/course-construction";
import Comment from "./comment";
import { CommentProps, ReplyValue } from "./comment/Reply";

interface DiscussProp {
  comments?: any
}

function Discuss({
  comments
}: DiscussProp) {
  const { t } = useTranslation();
  const { reloadDiscussion, setReloadDiscussion } = CourseManagementStore()

  const discussions =
    comments?.discussions?.map((dis: DiscussionProps) => ({
      ...dis.rootComment,
      level: 1,
      replies:
        dis.subComments
          .filter((comment: CommentsBeProps) => comment.level === 2)
          ?.map((commentLv2: CommentsBeProps) => ({
            ...commentLv2,
            parent: commentLv2.parentId,
            replies:
              dis.subComments
                .filter(
                  (cmt: CommentsBeProps) =>
                    cmt.level === 3 && cmt.parentId === commentLv2.id
                )
                ?.map((commentLv3: CommentsBeProps) => ({
                  ...commentLv3,
                  parent: commentLv3.parentId,
                  replies: [],
                })) || [],
          })) || [],
    })) || [];

  const handleReplyComment = async (value: ReplyValue) => {
    const payload: any = new FormData();
    payload.append("content", `${value?.replyText}`);
    payload.append("parentId", `${value?.comment?.level === 3 ? value?.comment?.parentId : value?.comment?.id}`);
    Array.from(value?.file).forEach((file) => {
      payload.append("attachments", file);
    });
    try {
      await teacherReplyStudent(payload);
      setReloadDiscussion(!reloadDiscussion);
    } catch (err) { } finally {
    }
  };

  const handleSaveEditComment = async (value: ReplyValue) => {
    const payload: any = new FormData();
    payload.append("id", `${value?.comment?.id}`);
    payload.append("content", `${value?.replyText}`);
    Array.from(value?.file).forEach((file) => {
      payload.append("attachments", file);
    });
    payload.append(
      "deleteAttachmentIds",
      `${value?.attachmentRemoved?.join(",")}`
    );
    try {
      await updateTeacherReplyStudent(payload);

      setReloadDiscussion(!reloadDiscussion);
    } catch (err) { } finally {
    }
  };

  const handleDeleteComment = (comment: CommentProps) => {
    Modal.confirm({
      title: t("Xác nhận xoá thảo luận", "Xác nhận xoá thảo luận"),
      icon: <ExclamationCircleFilled />,
      content:
        t("Thảo luận đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá thảo luận?", "Thảo luận đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá thảo luận?"),
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Huỷ", "Huỷ"),
      centered: true,
      onOk: async () => {
        try {

          await deleteTeacherReplyStudent(comment.id);
          message.success(t("Xoá thành công", "Xoá thành công"));
          setReloadDiscussion(!reloadDiscussion);
        } catch (err: any) { }
      },
      onCancel() { },
    });
  };
  return (
    <div
      className={`statistic-course-discuss`}
    >
      {discussions?.length > 0 ? (
        discussions?.map((discussion: any) => (
          <div className={`discuss-content`} key={discussion.id}>
            <Comment
              data={discussion}
              onReply={handleReplyComment}
              onSaveEditComment={handleSaveEditComment}
              onDelete={handleDeleteComment}
            />
          </div>
        ))
      ) : (
        <div className="center statistic-course-discuss-empty">
          <Empty description={t("Không có bình luận", "Không có bình luận")}></Empty>
        </div>
      )}

    </div>
  );
}

export default Discuss;
